import styled from '@emotion/styled'

export const CurrentCustomerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 1.5rem;
`

export const AppointmentCustomerLabel = styled.p`
  color: #3c4043;
  cursor: default;
  display: block;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 500;
  justify-content: center;
  letter-spacing: 0.25px;
  line-height: 35px;
  opacity: 1;
  text-decoration: none;
  text-transform: none;
  margin: 1.5rem 0;
`

export const AppointmentCustomerLink = styled(AppointmentCustomerLabel)`
  color: #005cd9;
  cursor: pointer;
  text-decoration: underline;
  margin: 1.5rem 0 1.5rem 0.5rem;
`
